import { render, staticRenderFns } from "./ConnectionTabOutput.vue?vue&type=template&id=8d4811a4&scoped=true"
import script from "./ConnectionTabOutput.vue?vue&type=script&lang=ts"
export * from "./ConnectionTabOutput.vue?vue&type=script&lang=ts"
import style0 from "./ConnectionTabOutput.vue?vue&type=style&index=0&id=8d4811a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4811a4",
  null
  
)

export default component.exports